// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-12420ca8]{position:relative;border:1px solid #789;top:-1em}.card .closeIcon[data-v-12420ca8]{position:absolute;top:.5em;right:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
